import { readForumAttribute } from './helpers';
function isAdmin() {
  try {
    const u = app.session && app.session.user;
    return !!(u && typeof u.isAdmin === 'function' && u.isAdmin());
  } catch (e) {
    return false;
  }
}
export function canCreateWikiArticle() {
  try {
    if (!app.session || !app.session.user) return false;
    if (isAdmin()) return true;
    return !!readForumAttribute('canCreateWikiArticle');
  } catch (e) {
    return false;
  }
}
export function canEditWikiArticles() {
  try {
    if (!app.session || !app.session.user) return false;
    if (isAdmin()) return true;
    return !!readForumAttribute('canEditWikiArticles');
  } catch (e) {
    return false;
  }
}
export function canReportWikiArticle() {
  try {
    if (!app.session || !app.session.user) return false;
    if (isAdmin()) return true;
    return !!readForumAttribute('canReportWikiArticle');
  } catch (e) {
    return false;
  }
}
export function canCommentWiki() {
  try {
    if (!app.session || !app.session.user) return false;
    if (isAdmin()) return true;
    return !!readForumAttribute('canCommentWiki');
  } catch (e) {
    return false;
  }
}

// No logged-in requirement: history is guest-visible unless an admin
// restricts the permission, and the attribute is serialized for guests too.
export function canViewWikiHistory() {
  try {
    if (isAdmin()) return true;
    return !!readForumAttribute('canViewWikiHistory');
  } catch (e) {
    return false;
  }
}
flarum.reg.add('linkrobins-wiki', 'forum/utils/permissions', { canCreateWikiArticle: canCreateWikiArticle,canEditWikiArticles: canEditWikiArticles,canReportWikiArticle: canReportWikiArticle,canCommentWiki: canCommentWiki,canViewWikiHistory: canViewWikiHistory, });